// extracted by mini-css-extract-plugin
module.exports = {"laptop":"(min-width: 1025px)","tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","switch__root":"switch__root-2plSa","switch__text":"switch__text-1febM"};